import type { SxProps, Theme } from '@mui/material/styles';
import {
  courseListPrimaryTypographySx,
  courseListSecondaryTypographySx,
} from '../courses/courseMuiStyles';

/** Dashboard shell — uses horizontal space on wide / 4K viewports. */
export const dashboardShellSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: {
    xs: '100%',
    lg: 1280,
    xl: 1600,
    xxl: 2100,
    xxxl: 2600,
  },
  mx: 'auto',
  px: { xs: 2, sm: 3, xxl: 4, xxxl: 5 },
  py: { xs: 2, md: 2.5, xxl: 3, xxxl: 3.5 },
};

export const dashboardTitleSx: SxProps<Theme> = {
  fontSize: { xs: '1.75rem', sm: '2rem', xxl: '2.125rem', xxxl: '2.375rem' },
  fontWeight: 600,
  mb: { xs: 2, xxl: 2.5 },
};

/** Full-width review backlog, then two columns on wide desktop. */
export const dashboardMainGridSx: SxProps<Theme> = {
  display: { xs: 'flex', xxl: 'grid' },
  flexDirection: 'column',
  gridTemplateColumns: { xxl: 'minmax(0, 1fr) minmax(0, 1fr)' },
  alignItems: 'start',
  gap: { xs: 2.5, xxl: 3, xxxl: 3.5 },
};

export const dashboardMainColumnSx: SxProps<Theme> = {
  width: '100%',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: 2.5, xxl: 3, xxxl: 3.5 },
};

export const dashboardSectionPaperSx: SxProps<Theme> = {
  p: { xs: 2, xxl: 2.25, xxxl: 2.5 },
};

export const dashboardSectionTitleSx: SxProps<Theme> = {
  fontSize: { xs: '1.125rem', sm: '1.25rem', xxl: '1.375rem', xxxl: '1.5rem' },
  fontWeight: 600,
};

export const dashboardInteractiveCardSx: SxProps<Theme> = {
  p: { xs: 1.5, xxl: 1.75, xxxl: 2 },
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  transition: 'background-color 0.15s ease',
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      bgcolor: 'action.hover',
    },
  },
};

export const dashboardCardTitleSx: SxProps<Theme> = courseListPrimaryTypographySx;

export const dashboardCardSecondarySx: SxProps<Theme> =
  courseListSecondaryTypographySx;

/** Puzzle spotlight boards — larger caps on wide viewports. */
export const DASHBOARD_PUZZLE_MAX_BOARD_WIDTH = {
  xs: 360,
  xxl: 480,
  xxxl: 580,
} as const;
